import { Box, Typography, Paper } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useReportContext } from '../ReportContext';
import { inventoryDropDown } from '../../newReports/data';
import { useSearchParams, useParams } from 'react-router-dom';
import ClosingStockSummary from '../../../../features/StockManagement/pages/ClosingStockSummary';
import StockItemWiseSummary from '../../../../features/StockManagement/pages/StockItemWiseSummary';

const ItemInventory = () => {
  const { updateReportData } = useReportContext();
  const [searchParams] = useSearchParams();
  const { id: reportId } = useParams();
  const previousReportIdRef = useRef(reportId);
  const [selectedReport, setSelectedReport] = useState(null);

  // Get includeOpeningBalance from URL search params
  const includeOpeningBalanceParam = searchParams.get('includeOpeningBalance');
  const includeOpeningBalance = includeOpeningBalanceParam !== null ? includeOpeningBalanceParam === 'true' : true;

  // Map account IDs to report types and components
  const reportTypeMap = {
    102: {
      component: 'StockItemWiseSummary',
      accountName: 'Stock & Item wise P&L',
    },
    101: {
      component: 'ClosingStockSummary',
      accountName: 'Stock Ledger',
    },
  };

  // Update context with available Inventory accounts for the header dropdown
  // Only update if reportId is '9' to avoid unnecessary updates
  useEffect(() => {
    if (reportId === '9') {
      updateReportData({
        allAccounts: inventoryDropDown,
        loading: false,
      });
    }
  }, [reportId, updateReportData]);

  // Clear data when report ID changes
  useEffect(() => {
    if (previousReportIdRef.current !== reportId && previousReportIdRef.current !== null) {
      setSelectedReport(null);
    }
    previousReportIdRef.current = reportId;
  }, [reportId]);

  // Fetch and display report based on URL 'ids'
  useEffect(() => {
    const idsParam = searchParams.get('ids');

    if (!idsParam) {
      setSelectedReport(null);
      return;
    }

    const decodedIds = decodeURIComponent(idsParam);
    const currentSelectedIds = decodedIds
      .split(',')
      .filter(Boolean)
      .map((id) => id.trim());

    // For single select, take the first ID
    const accountId = currentSelectedIds[0];

    if (accountId) {
      const matchingData = inventoryDropDown.find((item) => String(item.accountsid) === String(accountId));
      if (matchingData && reportTypeMap[accountId]) {
        setSelectedReport({
          accountId,
          ...reportTypeMap[accountId],
        });
      } else {
        setSelectedReport(null);
      }
    } else {
      setSelectedReport(null);
    }
  }, [searchParams, reportId]);

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      {!selectedReport ? (
        <Paper>
          <Typography variant="h4" gutterBottom>
            Item & Inventory Reports
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Please select a report type from the header to view Item & Inventory reports
          </Typography>
        </Paper>
      ) : (
        <Box>
          {selectedReport.component === 'ClosingStockSummary' ? (
            <ClosingStockSummary variant="component" includeOpeningBalance={includeOpeningBalance} />
          ) : (
            <StockItemWiseSummary variant="component" includeOpeningBalance={includeOpeningBalance} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default ItemInventory;
